import {
  ContentIds
} from "./chunk-6XYU3377.mjs";
import {
  __spreadValues
} from "./chunk-WNQUEZJF.mjs";

// src/listeners/media-listeners/media-listeners.ts
import { setupMediaListeners } from "@youversion/analytics-core";
var MediaListeners = {
  AudioBibleReference: {
    setup: (element, params) => {
      return setupMediaListeners(element, __spreadValues({
        contentType: "audio_bible_reference"
      }, ContentIds.AudioBibleReference(params)));
    }
  },
  GuidedPrayerBackgroundAudio: {
    setup: (element, params) => {
      return setupMediaListeners(element, __spreadValues({
        contentType: "guided_prayer_background_audio"
      }, ContentIds.GuidedPrayerBackgroundAudio(params)));
    }
  },
  PlanDevotionalAudio: {
    setup: (element, params) => {
      return setupMediaListeners(element, __spreadValues({
        contentType: "plan_devotional_audio"
      }, ContentIds.PlanDevotionalAudio(params)));
    }
  },
  Video: {
    setup: (element, params) => {
      return setupMediaListeners(element, __spreadValues({ contentType: "video" }, ContentIds.Video(params)));
    }
  }
};

export {
  MediaListeners
};
